import { CustomConfig } from "../models/CustomConfig"

export let CONFIG: CustomConfig | undefined

export class ConfigService {
    public static loadConfig = async (): Promise<any> => {
        return await fetch(`/api/v1/config`)
            .then((response) => response.json())
            .then((data) => setConfig(data))
    }
}

const setConfig = (config: CustomConfig | undefined) => {
    CONFIG = config
    return config
}
